import React, { useEffect, useState } from 'react'
import './managing-container.styles.scss';

import ManagingList from './managing-list.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRocket } from '@fortawesome/free-solid-svg-icons';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import AgeCheck from '@/components/layout-auth/age-check/age-check.component';
import { useSelector } from 'react-redux';
import { membershipRestrictions, testMemberRestrictions } from '@/utils/membershipRestrictions';
import UpgradeRequiredModal from '@/components/SHARED/upgrade-required-modal/upgrade-required-modal.component';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import StartingPointModal from '../create-edit-game/starting-point-modal.component';
import CopyGame from './copy-game.component';
import CreateFromTemplate from './create-from-template.component';

const ManagingContainer = ({ 
    orgs,
    managingList,
    archivedList
 }) => {

    const membership = useSelector(state => state.userData.membership);
    const userProfile = useSelector(state => state.userData.userProfile);
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ showUpgradeModal, setShowUpgradeModal ] = useState(null);
    const [ showStartingPoint, setShowStartingPoint ] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        changeDocumentTitle('Gamably | Games You Manage');
    }, [])

    function checkMembership() {
        if (!managingList || Object.values(managingList).length === 0) {
            setShowStartingPoint(true);
            return;
        }
        const res = testMemberRestrictions({'gameCount': Object.values(managingList).length, 'membership': membership});
        if (res.disabled && res.disabledReason.includes('games')) {
            const planRest = membershipRestrictions[membership.membership];
            const message = `While using the ${planRest.title}, you are only able to have ${planRest.gameCount} active Games.`;
            setShowUpgradeModal(message);
            return;
        }
        // navigate('/home/creategame')
        setShowStartingPoint(true);
    }

    return (
        <div className={`managing-container ${screenSize}`}>
            <AgeCheck />
            {/* <Layout> */}
            <Routes>
                <Route path='' element={
                    <div className={`managing-content ${screenSize}`}>
                        <div className={`g-card`}>
                            <div className='section-title with-icon'>
                                <div className='title'>Games You Manage</div>
                                {
                                    (userProfile) &&
                                    <button 
                                        className={`g-button ${screenSize === 'mobile' ? 'small-btn' : ''}`} 
                                        onClick={() => checkMembership()}>
                                        {
                                            screenSize == 'mobile'
                                            ?
                                            'New Game'
                                            :
                                            <>
                                            <span>Create a New Game</span>
                                            <FontAwesomeIcon 
                                            icon={faRocket} 
                                            size="lg" />
                                            </>
                                        }
                                        
                                    </button>
                                }
                            </div>
                            <div className="g-space-1"></div>
                            <hr className='no-top-margin' />
                            <ManagingList 
                                managingList={managingList}
                                archivedList={archivedList} />
                        </div>
                        {
                            (screenSize === 'mobile') 
                            ? 
                            <div className="g-space-1"></div>
                            :
                            <div className="g-space-1-5"></div>
                        }  
                    </div>
                }></Route>
                <Route path='copy' element={
                    <CopyGame
                        managingList={managingList} />
                }></Route>
                <Route path='fromtemplate/*' element={
                    <CreateFromTemplate
                        managingList={managingList} />
                }></Route>
                <Route path="*" element={<Navigate replace to="/404" />} />
            </Routes>
            <UpgradeRequiredModal 
                show={showUpgradeModal} 
                cancel={() => setShowUpgradeModal(false)} 
                closeButton={true} 
                message={showUpgradeModal} 
            />
            {/* </Layout> */}
            <StartingPointModal
                show={showStartingPoint}
                cancel={() => setShowStartingPoint(false)} />
        </div>
    )
}

export default ManagingContainer